import requestUtils from 'api/requestUtils'
import { BusinessResponses, paths } from '@luxuryescapes/contract-business'

export enum EmailOrDomainExistsErrorCode {
  EMAIL_ALREADY_EXISTS = 'EMAIL_ALREADY_EXISTS',
  DOMAIN_ALREADY_EXISTS = 'DOMAIN_ALREADY_EXISTS',
}

type EmailOrDomainExistsErrorEntry =
  paths['/api/business-traveller/businesses/email-or-domain-exists']['get']['responses'][403]['content']['application/json']['errors'][number]
type EmailLinkState = Extract<EmailOrDomainExistsErrorEntry, { linked: boolean }>

async function requestCheckEmailAndDomainAssociation(email: string, includeLinkState = false) {
  const query = `email=${encodeURIComponent(email)}${includeLinkState ? '&includeLinkState=true' : ''}`

  return await requestUtils.get<BusinessResponses.BaseResponse<null>>(`/api/business-traveller/businesses/email-or-domain-exists?${query}`)
}

/**
 * Reads the linked-account state svc-business attaches to an EMAIL_ALREADY_EXISTS response
 * (a `{ linked }` entry in the error `errors` array, present only when `includeLinkState` is requested).
 */
export function isExistingBusinessAccountLinked(error: App.ApiCallFailure): boolean {
  const linkStateEntry = (error.errors as Array<string | EmailLinkState> | undefined)?.find(
    (entry): entry is EmailLinkState => typeof entry === 'object' && entry !== null,
  )

  return !!linkStateEntry?.linked
}

export default requestCheckEmailAndDomainAssociation
